import { systemDefaultValues } from '@a1/shared';

const formatDateTime = (dateValue: string | Date): string => {
  if (!dateValue) return '';

  const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;

  return date.toLocaleString(systemDefaultValues.locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

export { formatDateTime };
